/**
 * Created by tiago on 11-10-17.
 */



var $ = require('js/sw-jquery/sw-jquery');

$(document).ready(function() {
  $('body').on('click', '[data-sw-datepicker]', function () {
    var $el = $(this);
    $el.datepicker({
      dateFormat: 'yy-mm-dd'
    });
  });
});

